import React, { forwardRef } from 'react';
import Localize from 'react-intl-universal';

import MuiAlert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';

import { notificationType } from '@components/Notifications/Constants';
import { useGlobalContext } from '@hooks/Context/GlobalContext';

const Alert = forwardRef(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant='filled'
      {...props}
      slotProps={{ closeButton: { title: `${Localize.get('App.close')}` } }}
    />
  );
});

const VERTICAL = 'bottom';
const HORIZONTAL = 'center';
const DEFAULT_DURATION = 2000;

const Notification = ({ message = '', severity = notificationType.info, open }) => {
  const [contextData, setContextData] = useGlobalContext();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setContextData({ ...contextData, open: false });
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={DEFAULT_DURATION}
      onClose={handleClose}
      anchorOrigin={{ vertical: VERTICAL, horizontal: HORIZONTAL }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        <Box data-test-id='snackbar-message'>{message}</Box>
      </Alert>
    </Snackbar>
  );
};

export default Notification;
